export default (() => {

    const global = {
        components: {},
        elements: {}
    };

    function initialise() {
        _cacheElements();
        _bindEvents();
    }

    function _cacheElements(){
        global.elements.confirmClear = document.querySelector('[data-signature-clear]');
        global.elements.confirmPermission = document.querySelector('[data-signature-permission]');
        global.elements.form = document.querySelector('[data-confirm-form]');
        
        global.components.confirmButton = document.querySelector('[data-confirm-button');
    }

    function _bindEvents() {
        global.elements.confirmClear.addEventListener('change', _checkDeclarationsAndToggleSubmit);
        global.elements.confirmPermission.addEventListener('change', _checkDeclarationsAndToggleSubmit);

        global.components.confirmButton.addEventListener('click', _submitForm);
    }

    function _checkDeclarationsAndToggleSubmit(){
        const canSubmit = global.elements.confirmClear.checked && global.elements.confirmPermission.checked;

        global.components.confirmButton.disabledProp = !canSubmit;
    }

    function _submitForm() {
        global.components.confirmButton.disabledProp = true;
        global.elements.form.submit();
    }

    return { initialise };
})();